import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgRefresh(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.2564 5.45726L20.4992 3.72568L18.9714 1.74683L14.0655 5.53447C13.5191 5.95635 13.4181 6.74134 13.84 7.28779L17.6276 12.1937L19.6065 10.6659L17.4362 7.85492C22.14 8.54936 25.75 12.603 25.75 17.4999C25.75 22.8847 21.3848 27.2499 16 27.2499C10.6152 27.2499 6.25 22.8847 6.25 17.4999H3.75C3.75 24.2654 9.23451 29.7499 16 29.7499C22.7655 29.7499 28.25 24.2654 28.25 17.4999C28.25 11.5052 23.9441 6.51629 18.2564 5.45726Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRefresh);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
